{
  "pt": {
    "datatable": {
      "actions": {
        "add_filter": "Adicionar filtro",
        "bulk_action": "Ação em massa",
        "bulk_edit": "Editar em massa",
        "clear": "Limpar",
        "clear_filters": "Limpar filtros",
        "collapse_all": "Recolher tudo",
        "collapse_row": "Recolher linha",
        "deselect_all": "Desmarcar tudo",
        "expand_all": "Expandir tudo",
        "expand_row": "Expandir linha",
        "filters": "Filtros",
        "remove_filter": "Remover o filtro {label}: {value}",
        "select_all": "Selecionar tudo",
        "select_row": "Selecionar linha"
      },
      "import": {
        "error_row": "Linha {row}",
        "errors_description": "A importação foi cancelada porque {count} linha(s) continham erros. Nenhum registo foi importado.",
        "errors_title": "Falha na importação",
        "success": "Ficheiro importado com sucesso",
        "title": "Importar"
      },
      "labels": {
        "active_filters": "Filtros ativos",
        "columns_selected": "{count} colunas selecionadas",
        "freeze_columns": "Congelar colunas",
        "freeze_rows": "Congelar linhas",
        "gridlines": "Linhas de grelha",
        "group_by": "Agrupar por",
        "size": "Tamanho",
        "sticky_headers": "Cabeçalhos fixos",
        "striped_rows": "Linhas listradas",
        "toggle_columns": "Alternar colunas",
        "translation_mode_header": "Cabeçalho",
        "translation_mode_stacked": "Empilhado",
        "translation_mode_toolbar": "Global",
        "translation_style": "Estilo de tradução"
      }
    }
  }
}
